import { PRODUCT_NAMES } from './productsNamesAndTypes';

export const SERVICE_ACTIVATION_PRODUCTS_TYPES = {
  BBProduct: PRODUCT_NAMES.BBProduct,
  CVEProduct: PRODUCT_NAMES.CVEProduct,
  nonHalo: 'nonHalo',
  BBAndCVE: 'BBAndCVE',
  BBAppointmentAndCVE: 'BBAppointmentAndCVE',
  BBAppointment: 'BBAppointment',
};
